import React, { useRef } from 'react';
import { Box, Divider } from '@mui/material';
import {
  FormProps,
  FormHeader,
  ClientNameField,
  DocumentUploadArea,
  FactsDescriptionField,
  PieceToRebutField,
  AudioRecordingSection,
  WritingStyleSelector,
  InfoTip,
} from './shared';

// Opções para pedido de levantamento de valores
const PECAS_REFERENCIA = [
  'Sentença',
  'Guia de Depósito',
  'Comprovante Bancário',
  'Processo Inteiro',
  'Outro'
];

const PedidoLevantamentoValoresForm: React.FC<FormProps> = ({
  documentType,
  values,
  onChange,
  uploadedFiles,
  onFileUpload,
  onFileRemove,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedStyle, setSelectedStyle] = React.useState(values.estilo_escrita || 'padrao');

  const handleFieldChange = (fieldId: string, value: any) => {
    onChange({
      ...values,
      [fieldId]: value,
    });
  };

  const handleRecordingComplete = (audioBlob: Blob) => {
    const audioFile = new File([audioBlob], `audio_${Date.now()}.webm`, {
      type: 'audio/webm',
    });
    onFileUpload([audioFile]);
  };

  return (
    <Box>
      <FormHeader 
        documentType={documentType}
        customTitle="Pedido de Levantamento de Valores"
        customDescription="Requerimento para liberação de valores depositados em juízo"
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {/* 1. Nome do Cliente */}
        <ClientNameField
          value={values.nome_cliente || ''}
          onChange={(value) => handleFieldChange('nome_cliente', value)}
        />

        {/* 2. Upload de Documentos */}
        <DocumentUploadArea
          uploadedFiles={uploadedFiles}
          onFileUpload={onFileUpload}
          onFileRemove={onFileRemove}
          suggestedDocs="Comprovante bancário, Guia de depósito, Processo na íntegra e Sentença."
          fileInputRef={fileInputRef as React.RefObject<HTMLInputElement>}
        />

        {/* 3. Descrição dos Fatos (Opcional) */}
        <FactsDescriptionField
          value={values.fatos_caso || ''}
          onChange={(value) => handleFieldChange('fatos_caso', value)}
          placeholder="Descreva os fundamentos do pedido, como trânsito em julgado, satisfação do crédito, acordo homologado, etc..."
        />

        {/* 4. Peça de referência */}
        <PieceToRebutField
          value={values.peca_rebater || 'Sentença'}
          onChange={(value) => handleFieldChange('peca_rebater', value)}
          otherValue={values.peca_rebater_outro || ''}
          onOtherChange={(value) => handleFieldChange('peca_rebater_outro', value)}
          options={PECAS_REFERENCIA}
          label="Indique a peça do processo que fundamenta o levantamento:"
        />

        {/* Gravação de Áudio */}
        <AudioRecordingSection
          onRecordingComplete={handleRecordingComplete}
          description="Grave um áudio descrevendo os detalhes do pedido que a IA irá transcrever automaticamente."
        />
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Estilo de Escrita */}
      <WritingStyleSelector
        selectedStyle={selectedStyle}
        onStyleChange={(styleId) => {
          setSelectedStyle(styleId);
          handleFieldChange('estilo_escrita', styleId);
        }}
      />

      <InfoTip message="Anexe a sentença, o comprovante de depósito e demais documentos que fundamentem o direito ao levantamento. Informe os dados bancários completos para transferência (banco, agência, conta, tipo de conta e CPF/CNPJ do titular)." />
    </Box>
  );
};

export default PedidoLevantamentoValoresForm;

